/*
  MEDTUTORS — Serv.ai Icon Fix + Drawer Price Fix
  In theme.liquid vor </body> einbauen:
  <script src="{{ 'medtutors-servai-fixes.js' | asset_url }}" defer></script>
*/

/* ============================================================
   1. SERV.AI ICON FIX
   ============================================================ */
(function () {

  var SVG_CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;display:inline-block;vertical-align:middle;flex-shrink:0;position:relative;top:-1px"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
  var SVG_HOURGLASS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;display:inline-block;vertical-align:middle;flex-shrink:0;position:relative;top:-1px"><path d="M5 22h14"/><path d="M5 2h14"/><path d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22"/><path d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2"/></svg>';

  function fixIcons() {
    document.querySelectorAll('.svv-event-card-item, .grid-layout-item, .mt-kurs-kachel').forEach(function(card) {
      var badges = card.querySelectorAll('.card-type-item-badge');
      badges.forEach(function(badge, i) {
        var iconWrap = badge.querySelector('.item-icon');
        if (!iconWrap) return;
        if (iconWrap.querySelector('circle, polyline, path[d*="22h14"]')) return;
        iconWrap.innerHTML = (i === 0) ? SVG_CLOCK : SVG_HOURGLASS;
        iconWrap.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;width:16px;height:16px;flex-shrink:0;vertical-align:middle';
      });

      var walker = document.createTreeWalker(card, NodeFilter.SHOW_TEXT, null, false);
      var nodes = [];
      var n;
      while ((n = walker.nextNode())) nodes.push(n);
      nodes.forEach(function(textNode) {
        var t = textNode.textContent;
        if (/🕐|🕑|🕒|🕓|🕔|🕕|🕖|🕗|🕘|🕙|🕚|🕛|\u23F0|\u231A/.test(t)) {
          var cleaned = t.replace(/[\u{1F550}-\u{1F567}]|\u23F0|\u231A/gu, '').trim();
          var span = document.createElement('span');
          span.style.cssText = 'display:inline-flex;align-items:center;gap:4px;font-size:inherit;color:inherit';
          span.innerHTML = SVG_CLOCK + cleaned;
          textNode.parentNode && textNode.parentNode.replaceChild(span, textNode);
        } else if (/\u23F1|\u23F3|\u231B/.test(t)) {
          var cleaned2 = t.replace(/\u23F1|\u23F3|\u231B/g, '').trim();
          var span2 = document.createElement('span');
          span2.style.cssText = 'display:inline-flex;align-items:center;gap:4px;font-size:inherit;color:inherit';
          span2.innerHTML = SVG_HOURGLASS + cleaned2;
          textNode.parentNode && textNode.parentNode.replaceChild(span2, textNode);
        }
      });
    });
  }

  function fixLinks() {
    document.querySelectorAll('.svv-wgt-container a, #svv-wgt-app a, .events-data-container a').forEach(function(a) {
      if (a._mtFixed) return;
      a._mtFixed = true;
      a.addEventListener('click', function(e) {
        var href = a.getAttribute('href') || '';
        if (!href || href === '#') return;
        var isInternal = href.startsWith('/') ||
          href.indexOf(window.location.hostname) > -1 ||
          href.indexOf('myshopify.com') > -1 ||
          href.indexOf('/products/') > -1;
        if (isInternal) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.location.href = href;
        }
      }, true);
    });

    document.querySelectorAll('.mt-kurs-kachel, .mt-buchen-btn').forEach(function(el) {
      if (el._mtFixed) return;
      el._mtFixed = true;
      el.addEventListener('click', function() {
        var orig = window.open;
        window.open = function(url, target) {
          if (url && (url.startsWith('/') || url.indexOf(window.location.hostname) > -1)) {
            window.location.href = url;
            return null;
          }
          return orig.apply(window, arguments);
        };
        setTimeout(function() { window.open = orig; }, 600);
      }, true);
    });
  }

  function applyAll() {
    fixIcons();
    fixLinks();
  }

  var timer;
  new MutationObserver(function(mutations) {
    if (mutations.some(function(m) { return m.addedNodes.length > 0; })) {
      clearTimeout(timer);
      timer = setTimeout(applyAll, 150);
    }
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }
  setTimeout(applyAll, 800);
  setTimeout(applyAll, 2500);

})();


/* ============================================================
   2. CART DRAWER: PREISFORMAT
   Entfernt Dezimalstellen, behält Währung (CHF/€/Ft) wie Shopify sie liefert.
   Kein Cache (_mtDrawerDone) damit jeder Aufruf sauber arbeitet.
   ============================================================ */
(function() {

  /* Entfernt ".00" oder ",00" aus einem Preisstring, egal wo */
  function stripDecimals(str) {
    return str.replace(/(\d)[.,]0{2}(?=[^0-9]|$)/g, '$1').trim();
  }

  function formatDrawerPrices() {

    /* Gesamtpreis + Zeilenpreise: text-component Web Component
       value Attribut enthält z.B. "CHF 29.00" oder "29.00€" */
    document.querySelectorAll('.cart-drawer text-component').forEach(function(el) {
      var val = el.getAttribute('value') || '';
      if (!val) return;
      var clean = stripDecimals(val);
      if (clean !== val.trim()) {
        el.textContent = clean;
      }
    });

    /* Einzel-Preise im Drawer (span: "28 CHF" oder "1 CHF") */
    document.querySelectorAll('.cart-drawer .cart-items__unit-price-wrapper span:not(.visually-hidden)').forEach(function(el) {
      /* Nur Text-Nodes patchen, keine Elemente mit Kinder-HTML */
      if (el.children.length > 0) return;
      var raw = el.textContent || '';
      var clean = stripDecimals(raw);
      if (clean !== raw.trim()) {
        el.textContent = clean;
      }
    });
  }

  /* Drawer öffnen triggert MutationObserver */
  var drawerTimer;
  new MutationObserver(function() {
    clearTimeout(drawerTimer);
    drawerTimer = setTimeout(formatDrawerPrices, 200);
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  /* Fallback-Timeouts für träge Drawer-Initialisierung */
  setTimeout(formatDrawerPrices, 400);
  setTimeout(formatDrawerPrices, 1200);
  setTimeout(formatDrawerPrices, 3000);

})();